import * as $ from 'jquery';

$(document).ready(function () {
    var win = $(window);
    $(window).scroll(function () {
      var page = {
        top: win.scrollTop(),
        left: win.scrollLeft()
      };
      if (page.top >= 250) {
        $('.header').addClass('is-fixed');
        $('.header').removeClass('nop')
        $('#sidebar-toggle').removeClass('logo-white')
        $('#sidebar-toggle').addClass('logo-black')
        $('.nav-menu li a').css({
          color: '#818285'
        })
        $('.back-button').css({
          color: '#818285'
        })
      } else {
        if ($(".header").hasClass("is-fixed")) {
          $('.header').removeClass('is-fixed')
          $('.header').addClass('nop')
          $('#sidebar-toggle').removeClass('logo-blue')
          $('#sidebar-toggle').addClass('logo-white')
          $('.nav-menu li a').css({
            color: 'white'
          })
          $('.back-button').css({
            color: 'white'
          })
        }
      }

      if (page.top >= 120) {
        $('#sidebar-toggle').removeClass('logo-white')
        $('#sidebar-toggle').addClass('logo-black')
      } else {
          $('#sidebar-toggle').removeClass('logo-blue')
          $('#sidebar-toggle').addClass('logo-white')
      }
      if (page.top < 160) {
        if ($(".header").hasClass("nop")) {
           $('.header').removeClass('nop')
        }
      }
    });

    var page = {
        top: win.scrollTop(),
        left: win.scrollLeft()
      };

    if (page.top >= 120) {
        $('#sidebar-toggle').removeClass('logo-white')
        $('#sidebar-toggle').addClass('logo-black')
      } else {
          $('#sidebar-toggle').removeClass('logo-blue')
          $('#sidebar-toggle').addClass('logo-white')
      }

  });  


// WEBPACK FOOTER //
// ./src/pages/home/scripts/header/index.js